// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47b3463c","396":"0a7572b5","453":"788c03d0","455":"57c952be","977":"92b122bd"}[chunkId] + ".chunk.js";
};